import $ from 'jquery';

$(function () {
  if ($(window).width() > 992) {
    $(document).on('click', '#copy_paste_button', function() {
      let url = $('#copy_btn_url').val();
      let messageSuccess = $('.share-copied-success');

      navigator.clipboard.writeText(url);
      messageSuccess.css('display', 'block');

      // Hide msg after 2s
      setTimeout(function () {
        messageSuccess.css('display', 'none');
      }, 1500);
    });
  }
});
